import { useTranslation } from "@msuite/ui/localization";
import Notes from "@/components/notes";
import type { NoteHintButtonProps } from "@/components/notes/note-hint-button";

/** Props Interface */
interface ProjectTimelineItemNotesProps extends NoteHintButtonProps {
	disableIncludeInDiary?: boolean;
}

export function ProjectTimelineItemNotes({
	notesTable,
	identifier,
	disclosure,
	disableIncludeInDiary,
}: ProjectTimelineItemNotesProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!disclosure.isOpen) return null;

	/** Render */
	return (
		<div className="pt-4 pl-18">
			<Notes
				notesTable={notesTable}
				identifier={identifier}
				isImportantLabel={t("projects.include_note_in_diary")}
				withIsImportant
				withIsImportantIsDisabled={disableIncludeInDiary}
			/>
		</div>
	);
}
